var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable } from 'mobx';
import { cachedSet } from '../../../../utils/mobx/decorators/customComputed';
import { uniq } from '../../../../utils/helper/lodash_replacements';
export class BidderTreeNode {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get actor() {
        return this.parent;
    }
    get allNodes() {
        const nodes = [];
        this.addRecursive(nodes);
        return uniq(nodes);
    }
    addRecursive(nodes) {
        if (!nodes.includes(this.actor)) {
            nodes.push(this.actor);
        }
        const directChildrenNotYetContained = this.ownChildren.filter(child => !nodes.includes(child));
        directChildrenNotYetContained.forEach(child => {
            if (child.exportingTreeNode) {
                child.exportingTreeNode.addRecursive(nodes);
            }
        });
    }
    get ownChildren() {
        const children = [];
        for (let i = 0; i < this.actor.importingChildren.length; i++) {
            let child = this.actor.importingChildren[i];
            if (typeof child === 'function') {
                child = child();
            }
            if (Array.isArray(child)) {
                children.push(...child);
            }
            else {
                children.push(child);
            }
        }
        return uniq(this.actor.importingChildren.filter(c => !!c));
    }
}
__decorate([
    cachedSet // improves performance
], BidderTreeNode.prototype, "allNodes", null);
